import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {ProvenanceListPage} from './ProvenanceListPage'
import {ProvenancePage} from './ProvenancePage'

const ProvenanceWrapper = () => {
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Paramètres',
                    path: '#',
                    isSeparator: false,
                    isActive: true,
                  },
                ]}
              >
                Provenances
              </PageTitle>
              <ProvenanceListPage />
            </>
          }
        />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Provenances', path: '/provenances', isSeparator: false, isActive: true},
                ]}
              >
                Création
              </PageTitle>
              <ProvenancePage />
            </>
          }
        />
        <Route
          path='/:provenanceId/modifier'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Provenances', path: '/provenances', isSeparator: false, isActive: true},
                ]}
              >
                Modification
              </PageTitle>
              <ProvenancePage />
            </>
          }
        />
        <Route index element={<Navigate to='/provenances/liste' />} />
      </Routes>
    </>
  )
}

export {ProvenanceWrapper}
